export default {
    PREFIX: 'alexandermisyura_DMT_task_',
};
